import styles from "./index.css";
import DeliveryProposition from "./DeliveryProposition";
import BagLinks from "./BagLinks";
import Subtotal from "./SubTotal";
import Delivery from "./Delivery";
import Fees from "./Fees";
import Total from "./Total";
import ErrorMessage from "../ErrorMessage";

const MinibagFooter = () => (
  <div data-test-id="miniBagFooter" className={styles.minibagFooter}>
    <div className={styles.error}>
      <ErrorMessage />
    </div>
    <div className={styles.pricingContainer}>
      <Subtotal />
      <Delivery />
      <Fees />
      <Total />
    </div>
    <BagLinks />
    <DeliveryProposition />
  </div>
);

export default MinibagFooter;
